import { SystemMessages } from 'utils/enums/system-message.enum'
import { addCustomIssue } from 'utils/schema.util'
import { z } from 'zod'
import { doNotHasText } from 'utils/validate.util'

export const socialNetworkSchema = z
  .object({
    id: z.number().nullish(),
    redeSocial: z.string().nullish(),
    descricao: z.string().nullish(),
  })
  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)

    if (doNotHasText(fields.redeSocial) && !doNotHasText(fields.descricao)) {
      addIssue('redeSocial', SystemMessages.MESSAGE_002)
    }
  })

export type SocialNetworkType = z.infer<typeof socialNetworkSchema>

export const socialNetworkInit: SocialNetworkType = {
  redeSocial: '',
  descricao: '',
}
